module.exports = __webpack_public_path__ + "svg/plane.svg?657297b41552e6b436b35d6536021e69";